<template>
  <!-- 参会人排座 -->
  <div class="bg-white mar-top">
    <back-route-hdr :back-mode="'func'" :cur-hash="'seats'"
                    @handle-back="handleBack(true)"></back-route-hdr>
    <div class="pad-all">
      <van-swipe>
        <van-swipe-item v-for="(ele, index) in seatPics" :key="index">
          <img :src="mgrResourceUrl + ele.url"/>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="bord-top mar-operate-btm">
      <van-cell :title="arrangement.length ? '座位安排' : '暂无座位安排'" @click="handleArrange()">
        <template #right-icon>
          <span>添加安排 <i class="fa fa-plus-circle"></i></span>
        </template>
      </van-cell>
      <van-cell v-for="(ele, idx) in arrangement" :key="ele.userId" center>
        <template #title>
          <span class="custom-title">{{ele.location}} - {{ele.name}}</span>
          <span v-show="ele.desc" class="text-lt text-sm text-nowrap">（{{ele.desc}}）</span>
        </template>
        <template #right-icon>
          <!-- 复制、编辑、移除 -->
          <i class="fa fa-copy text-lg mar-rgt-20" @click="handleArrange('-1', ele)"></i>
          <i class="fa fa-pencil text-lg mar-rgt-20" @click="handleArrange(idx)"></i>
          <van-icon name="clear" class="text-lg" @click="removeArrange(ele, idx)"></van-icon>
        </template>
      </van-cell>
    </div>

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button icon="arrow-left" size="small" class="mar-rgt" @click="handleBack(true)">返回</van-button>
        <van-button type="primary" size="small" @click="handleBack()">确定修改</van-button>
      </div>
    </div>
    <!-- 排座表单 -->
    <van-action-sheet v-model="showFormSheet" :title="forAdd ? '添加座位安排' : '修改座位安排'">
      <van-form label-align="right" label-width="80" validate-trigger="onSubmit" @submit="onSubmit">
        <van-field v-model="sheetDoc.location" label="座位编号" maxlength="10"
                   :rules="[{required: true, message: '请输入座位编号'}]"
                   name="location" placeholder="必填，请输入座位编号"></van-field>
        <van-field v-model="sheetDoc.desc" label="座位描述"
                   type="textarea" rows="1" autosize maxlength="20"
                   name="desc" placeholder="选填，请输入座位描述信息"></van-field>
        <van-field readonly clickable :value="sheetDoc.name"
                   label="参会人" placeholder="必填，点击选择参会人"
                   :rules="[{required: true, message: '请选择参会人'}]"
                   name="name" @click="showUserPicker = true"></van-field>
        <div class="mar-all">
          <van-button type="primary" block size="small">暂存</van-button>
        </div>
      </van-form>
    </van-action-sheet>

    <van-popup v-model="showUserPicker" round position="bottom">
      <van-cascader v-model="userVal" title="请选择参会人"
                    :options="participantOptions"
                    @close="showUserPicker = false"
                    @finish="onFinishUserSelect"></van-cascader>
    </van-popup>


  </div>
</template>

<script>
  import {frontConfirm} from "../../../../../tools/utils";

  const basicDoc = {
    location: "",
    userId: "",
    name: "",
    desc: "",
    isVisitor: false,  // 是否需要邮件、短信等通知
  };

  export default {
    props: {
      meetingRoom: Object,
      insideParticipant: Array,
      outsideParticipant: Array,
      seatsArrangement: Array,
    },
    data() {
      return {
        arrangement: [],
        forAdd: false,
        arrIdx: null,
        showFormSheet: false,
        sheetDoc: {...basicDoc},
        showUserPicker: false,
        userVal: ""
      }
    },
    computed: {
      mgrResourceUrl() {
        return this.$store.state.sysView.mgrSrcUrl || ""
      },
      seatPics() {
        return this.meetingRoom.seatPics || []
      },
      participantOptions() {
        return [
          {
            text: "参会人",
            value: 0,
            children: this.insideParticipant.map(e => ({
              text: e.name,
              value: e.userId
            }))
          },
          {
            text: "外部参会人",
            value: 1,
            children: this.outsideParticipant.map(e => ({
              text: e.name,
              value: e.tel  // todo: 可能需更改为自生成id
            }))
          },
        ]
      },
    },
    watch: {
      showFormSheet(val) {
        if (val) return;
        this.userVal = "";
        this.arrIdx = null;
        this.sheetDoc = {...basicDoc}
      }
    },
    created() {
      this.arrangement = [...this.seatsArrangement || []]
    },
    methods: {
      handleArrange(idx, doc) {
        if (this.arrangement[idx]) {
          // edit
          this.forAdd = false;
          this.arrIdx = idx;
          this.sheetDoc = {...this.arrangement[idx]};
          this.userVal = this.sheetDoc.userId
        } else {
          // add
          this.forAdd = true;
          if (doc) this.sheetDoc = {...doc, userId: "", name: ""}
        }
        this.showFormSheet = true
      },
      removeArrange(ele, idx) {
        frontConfirm({msg: `是否确认删除安排【${ele.location} - ${ele.name}】？`}, () => {
          this.arrangement.splice(idx, 1);
        })
      },
      onFinishUserSelect(data) {
        const [parent, user] = data.selectedOptions;
        // console.log({parent, user});
        if (parent.value) this.sheetDoc.isVisitor = true;
        this.sheetDoc = {
          ...this.sheetDoc,
          name: user.text,
          userId: user.value
        };
        this.showUserPicker = false
      },
      onSubmit() {
        // console.log(this.sheetDoc);
        if (this.arrangement.some((e, idx) => {
          if (idx === this.arrIdx) return false;
          if (e.location === this.sheetDoc.location) return true
        })) {
          vtToast(`座位编号【${this.sheetDoc.location}】重复`);
          return
        }

        const setArrangement = () => {
          if (this.forAdd) {
            this.arrangement.push(this.sheetDoc)
          } else {
            this.arrangement[this.arrIdx] = this.sheetDoc
          }
          this.showFormSheet = false;
        };

        const existIdx = this.arrangement.findIndex((e, idx) => {
          if (idx === this.arrIdx) return false;
          if (e.userId === this.sheetDoc.userId) return true
        });
        // console.log(this.arrIdx, existIdx);
        if (~existIdx) {
          frontConfirm({msg: `参会人 ${this.sheetDoc.name} 已有其他座位安排，是否确认删除原有安排？`}, () => {
            setArrangement();
            this.arrangement.splice(existIdx, 1);
          });
          return
        }
        setArrangement();
      },
      handleBack(rtn) {
        if (rtn && JSON.stringify(this.seatsArrangement) !== JSON.stringify(this.arrangement)) {
          frontConfirm({msg: "是否丢弃当前更改？"}, () => {
            this.$emit('change-info', null)
          });
          return
        }
        this.$emit('change-info', rtn ? null : this.arrangement)
      }
    }
  }
</script>

<style scoped>
</style>
